




































import { Component, Prop, Mixins } from "vue-property-decorator";
import { capitalize, titlecase } from "@apphq/utils";
import I18NextMixin from "../i18n/I18NextMixin";
import Title from "../elements/Title.vue";

@Component({
  components: {
    Title
  },
  filters: {
    capitalize,
    titlecase
  }
})
export default class ContactInfo extends Mixins(I18NextMixin) {
  /** Name of the contact person or company */
  @Prop({ type: String, required: true }) name!: string;
  /** Email address for contact */
  @Prop({ type: String, required: false }) email?: string;
  /** Phone number for contact */
  @Prop({ type: String, required: false }) phone?: string;
  /** Address for contact */
  @Prop({ type: String, required: false }) address?: string;
}
